import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-form-password',
  templateUrl: './form-password.component.html',
  styleUrls: ['./form-password.component.scss']
})
export class FormPasswordComponent {

  form : FormGroup
  unsubs = new Subject();
  showPass = false;

  constructor(
    public dialogRef: MatDialogRef<FormPasswordComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private fb: FormBuilder
    ) {
      this.form = this.fb.group({
        password: [null, [Validators.minLength(6)]],
      })
      if (data) {
        this.form.patchValue(data)
      }
    }

    onConfirm(): void {
      this.dialogRef.close(this.form.value);
    }

    onDismiss(): void {
      this.dialogRef.close(false)
    }

    toggle(): void {
      this.showPass = !this.showPass;
    }

}
